import { Checkbox, FormControlLabel, Link, Typography } from "@material-ui/core";
import React from "react";
import theme from "../../../assets/theme";
import { useLangLabels } from "../../../shared/lang/services/useLangLabels";

export const PRIVACY_POLICY_URLS = {
  es: "https://www.tgdcompany.com/politica-de-privacidad/",
  en: "https://www.tgdcompany.com/en/privacy-policy/",
};

interface PrivacyPolicyCheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
}

const PrivacyPolicyCheckbox: React.FC<PrivacyPolicyCheckboxProps> = ({
  checked,
  onChange,
  disabled,
}) => {
  const { lang } = useLangLabels();
  const privacyPolicyUrl =
    lang.selectedLanguage === "es" ? PRIVACY_POLICY_URLS.es : PRIVACY_POLICY_URLS.en;

  return (
    <FormControlLabel
      disabled={disabled}
      style={{ marginLeft: 0, marginRight: 0 }}
      control={
        <Checkbox
          required
          size="small"
          checked={checked}
          onChange={e => onChange(e.target.checked)}
          style={{
            padding: "0 4px 0 0",
            color: theme.palette.secondary.main as string,
          }}
        />
      }
      label={
        <Typography variant="body2">
          {lang.privacyPolicy.accept}{" "}
          <Link
            href={privacyPolicyUrl}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e: React.MouseEvent) => e.stopPropagation()}
            style={{ color: theme.palette.secondary.main as string }}
          >
            {lang.privacyPolicy.link}
          </Link>
        </Typography>
      }
    />
  );
};

export default PrivacyPolicyCheckbox;
